angular.module('aprima-legacy-common').factory('AprimaAnalytics', ['Bridge', '$timeout', '_',
        function (Bridge, $timeout, _) {
            'use strict';

            var sendTiming = function (category, label, timingValue, page) {
                $timeout(function () {
                    Bridge.trackTiming(category, label, timingValue, page);
                }, 0);
            };

            var sendEvent = function (category, action, label, value) {
                $timeout(function () {
                    Bridge.trackEvent(category, action, label, value);
                }, 0);
            };

            var sendPageView = function (location) {
                $timeout(function () {
                    Bridge.trackPageChange(location);
                }, 0);
            };

            var sendException = function (message) {
                $timeout(function () {
                    Bridge.trackException(message);
                }, 0);
            };

            var startTiming = function (page, category, label) {
                var now = new Date().getTime();
                var timing = {
                    startTime: now,
                    page: page,
                    label: label,
                    category: category
                };

                timing.stop = _.partial(stopTiming, timing);

                return timing;
            };

            function stopTiming(timing) {
                timing.endTime = new Date().getTime();
                timing.value = moment(timing.endTime).diff(moment(timing.startTime), 'millisecond');
                sendTiming(timing.category, timing.label, timing.value, timing.page);
            }

            return {
                sendEvent: sendEvent,
                sendTiming: sendTiming,
                sendPageView: sendPageView,
                sendException: sendException,
                startTiming: startTiming,
                stopTiming: stopTiming
            };
        }]
);
